module.exports = __webpack_public_path__ + "img/40_38_024_110.2d718101.jpg";